import React from 'react';
import { largeNumberFormatter } from '../utils/helpers'

const CustomTooltip = ({ active, payload, showTotal }) => {
   if(!active) return null;
      const title = payload?.[0]?.payload?.XAxis
      const total = payload?.length < 2 ? '': <p className="intro" style={{'fontWeight': 'bold'}}>{`Total: ${largeNumberFormatter(payload.reduce((sum, item) => sum + item.value, 0))}`}</p>;
      return (
        <div className="custom-tooltip" style={{backgroundColor:'#ffffff', padding:20, border:'1px solid gray'}}>
          <p className="label">{title}</p>
          {payload.map((element, index) => (
            <p key={index} className="intro" style={{'color':element.fill}}>{`${element.name}: ${largeNumberFormatter(element.value)}`}</p>
          ))}
          {showTotal && total}
        </div>
      );
  };

  export default CustomTooltip;
